<template>
  <div class="return-popup-container">
    <ReturnTitle>반품할 품목을 선택해주세요</ReturnTitle>
    <TableContainer>
      <ReturnTable>
        <thead>
          <tr>
            <ReturnTh>
              <ReturnCheckbox type="checkbox" v-model="allSelected" @change="toggleSelectAll" class="return-checkbox" />
            </ReturnTh>
            <ReturnTh>품목코드</ReturnTh>
            <ReturnTh>품목분류</ReturnTh>
            <ReturnTh>품목명</ReturnTh>
            <ReturnTh>수량</ReturnTh>
            <ReturnTh>단가</ReturnTh>
          </tr>
        </thead>
        <tbody>
          <tr v-for="(product, index) in localProducts" :key="index">
            <ReturnTd>
              <ReturnCheckbox type="checkbox" :checked="product.selected" @change="toggleProduct(index)"
                class="return-checkbox" />
            </ReturnTd>
            <ReturnTd>{{ product.code || product.b_product_id }}</ReturnTd>
            <ReturnTd>{{ product.name || product.name1 }}</ReturnTd>
            <ReturnTd>{{ product.name2 || product.name3 }}</ReturnTd>
            <ReturnTd>{{ product.quantity }}</ReturnTd>
            <ReturnTd>{{ formatPrice(product.buyprice || product.rentprice) }}</ReturnTd>
          </tr>
        </tbody>
      </ReturnTable>
    </TableContainer>

    <!-- 반품 유형 선택 영역 -->
    <ReturnTypeContainer>
      <ReturnTitle>반품 유형</ReturnTitle>
      <ReturnTypeSelect v-model="returnType">
        <option value="">반품 유형을 선택해주세요</option>
        <option value="0">다른 물건</option>
        <option value="1">파손</option>
        <option value="3">불량</option>
        <option value="4">단순 변심</option>
      </ReturnTypeSelect>
    </ReturnTypeContainer>

    <!-- 반품 요청사항 입력 영역 -->
    <ReturnNoteContainer>
      <ReturnTitle>반품 요청사항</ReturnTitle>
      <ReturnTextarea v-model="returnNote" placeholder="반품 요청사항을 입력해주세요." @input="updateReturnNote" />
    </ReturnNoteContainer>
  </div>
</template>

<script>
import * as OrderReturnPopupCss from '@/assets/styles/order/popup/OrderReturnPopupCss';

export default {
  name: 'OrderReturnPopup',

  components: {
    ...OrderReturnPopupCss
  },

  props: {
    products: {
      type: Array,
      required: true
    }
  },

  data() {
    return {
      allSelected: false,
      selectedProducts: [],
      localProducts: [],
      returnNote: '',
      returnType: '',
    }
  },

  computed: {
    canConfirm() {
      return this.selectedProducts.length > 0 &&
        this.returnNote.trim().length > 0 &&
        this.returnType !== '';
    }
  },

  methods: {
    updateReturnNote() {
      // 500자 제한
      if (this.returnNote.length > 500) {
        this.returnNote = this.returnNote.slice(0, 500);
      }
    },

    formatPrice(price) {
      return new Intl.NumberFormat('ko-KR').format(price || 0);
    },

    // 전체 선택
    toggleSelectAll(event) {
      const isChecked = event.target.checked;
      this.allSelected = isChecked;

      this.localProducts.forEach(product => {
        product.selected = isChecked;
      });

      this.updateSelectedProducts();
    },

    toggleProduct(index) {
      // 개별 제품의 선택 상태를 토글
      this.localProducts[index].selected = !this.localProducts[index].selected;

      // 전체 선택 상태 업데이트
      this.allSelected = this.localProducts.every(product => product.selected);

      this.updateSelectedProducts();
    },

    // 선택된 상품 업데이트
    updateSelectedProducts() {
      this.selectedProducts = this.localProducts
        .filter(product => product.selected)
        .map(product => ({
          ...product, // 모든 원본 데이터 유지
          id: product.id,
          b_product_id: product.b_product_id,
          product_id: product.product_id,
          num: product.num,
          code: product.code,
          name: product.name || product.name1,
          name1: product.name1,
          name2: product.name2 || product.name3,
          name3: product.name3,
          name4: product.name4,
          quantity: product.quantity || 1,
          quantity_piece: product.quantity_piece || 0,
          buyprice: product.buyprice || 0,
          rentprice: product.rentprice || 0,
          margin: product.margin || 0,
          margin_type: product.margin_type || 'a',
          selected_target: product.selected_target || '구입',
          options: {
            size: product.sizes || [],
            color: product.colors || [],
            bcode: product.barcodes || [],
            note: product.notes || []
          },
          icode: product.icode || '',
          location: product.location || '',
          stock_quantity: product.stock_quantity || 0,
          isSetItem: product.isSetItem || false,
          set_name: product.set_name,
          set_items: product.set_items,
          product_set_id: product.product_set_id,
          set_item_id: product.set_item_id
        }));

      console.log('선택된 품목 업데이트:', this.selectedProducts); // 디버깅용
    }
  },

  created() {
    // props로 받은 데이터를 로컬 데이터로 복사
    this.localProducts = this.products
      .filter(product => product.quantity > 0) // 수량이 있는 제품만
      .map(product => ({
        ...product,
        selected: false
      }));
  },

  watch: {
    products: {
      handler(newProducts) {
        // props가 변경될 때마다 로컬 데이터 업데이트
        this.localProducts = newProducts
          .filter(product => product.quantity > 0) // 수량이 있는 제품만
          .map(product => ({
            ...product,
            selected: false
          }));
      },
      deep: true
    }
  }
}
</script>